











import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import ProductsMixin from "@/mixins/http/ProductsMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "../../store/types/RequestData";
import ProductForm from "@/components/Product/Form.vue";

import { ProductPayload } from "../../models/Product";
import { showToast } from "../../utils/Toast";

const tag = "update_product";
const getTag = "get_product";

@Component({
  components: {
    ProductForm,
  },
})
export default class ProductCreate extends Mixins(ProductsMixin) {
  @RegisterHttp(tag) readonly updatesProductRequest: RequestData;
  @RegisterHttp(getTag) readonly getProductRequest: RequestData;

  product: ProductPayload = null;

  get loading() {
    return (
      this.updatesProductRequest?.loading && this.getProductRequest?.loading
    );
  }

  async onBluePrintChanged(blueprint: any) {
    if (!blueprint) {
      const product = await this.detachBlueprint(this.id, tag);
      this.product = ProductPayload.fromProduct(product);
    } else {
      const data = new FormData();
      data.append("blueprint", blueprint.file);
      const product = await this.updateProduct(this.id, data, tag);
      this.product = ProductPayload.fromProduct(product);
    }
  }

  mounted() {
    this.loadItem();
  }

  get requestTag() {
    return tag;
  }

  get id() {
    return this.$route.params.id;
  }

  async loadItem() {
    try {
      const product = await this.getProduct(this.id, getTag);
      this.product = ProductPayload.fromProduct(product);
    } catch (e) {
      showToast("An error occurred fetching the product", { type: "error" });
      this.back();
    }
  }

  back() {
    this.$router.go(-1);
  }

  onSave(product: ProductPayload) {
    const payload = {
      ...product,
      rotatable: product.rotatable ? "1" : "0",
    };
    this.updateProduct(product.id, product, tag).then(
      () => {
        showToast("Product updated successfully");
      },
      (err) => {
        if (err?.response?.status === 422) {
          showToast("Could not save product", {
            type: "error",
          });
        } else {
          showToast(
            "An error occurred while updating the product: " + err.message,
            {
              type: "error",
            }
          );
        }
      }
    );
  }
}
